import React, { useState, useRef, useEffect, forwardRef } from "react";
import "./TabManager.scss";

const WIDTH = 150;

const TabManager = forwardRef(({ tabs, changeTab }, ref) => {
  const [tab, setTab] = useState(0);
  const containerRef = useRef();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [hidePrevNextButtons, setHidePrevNextButtons] = useState(true);

  useEffect(() => {
    setHidePrevNextButtons(
      containerRef.current &&
        containerRef.current.scrollWidth <= containerRef.current.clientWidth
    );
  });

  useEffect(() => {
    if(changeTab){
      setTab(changeTab)
    }
  }, [changeTab])
  

  const handleScroll = (direction) => {
    const container = containerRef.current;
    const maxScroll = container.scrollWidth - container.clientWidth;
    const scrollIncrement = WIDTH;

    let newScrollPosition;

    if (direction === "left") {
      newScrollPosition = Math.max(0, scrollPosition - scrollIncrement);
    } else if (direction === "right") {
      newScrollPosition = Math.min(maxScroll, scrollPosition + scrollIncrement);
    }

    setScrollPosition(newScrollPosition);
    container.scrollLeft = newScrollPosition;
  };

  const renderTabButton = () => {
    const html = [];
    html.push();

    tabs?.forEach((tabEl, i) => {
      html.push(
        <div
          key={"tab-button-" + i}
          className={`tab-item ${tab === i ? "btn-active" : ""}`}
          onClick={() => {setTab(i); if(tabEl.onClick){tabEl.onClick()}}}
        >
          {tabEl.title}
        </div>
      );
    });

    return html;
  };

  const renderTabContent = () => {
    const html = [];
    tabs?.forEach((tabEl, i) => {
      if (tab === i) {
        html.push(
          <div key={"tab-content-" + i} className={"content"}>
            {tabEl.component}
          </div>
        );
      }
    });
    return html;
  };

  React.useImperativeHandle(ref, () => ({
    tabIndex: () => {
      return tab;
    },
    tabId: () => {
      return tabs[tab].id;
    },
  }));

  return (
    <div className={"tab-manager"}>
      <div className={"tab-buttons-wrapper"}>
        <div
          className={`prev ${hidePrevNextButtons && "hidden"}`}
          onClick={() => handleScroll("left")}
        >
          arrow_back_ios
        </div>
        <div className={"tab-buttons"} ref={containerRef}>
          {renderTabButton()}
        </div>
        <div
          className={`next ${hidePrevNextButtons && "hidden"}`}
          onClick={() => handleScroll("right")}
        >
          arrow_forward_ios
        </div>
      </div>
      <div className={"tab-content"}>{renderTabContent()}</div>
    </div>
  );
});

export default TabManager;
